import { getPluralize } from '@r1-frontend/shared/helpers/pluralize';
import { bonusPluralize } from '@r1-frontend/shared/helpers/pluralize/predifined';

import { getIsAbnLoyaltyProgramEnabled } from '~/src/features/domru-bonus/constants/abnVariants';
import { IHintProps } from '~/src/features/payments-abn/components/InfoHint';
import { TState } from '~/src/store';

const bonus = getPluralize(bonusPluralize);

const isAbnProgramTermsEnabled = getIsAbnLoyaltyProgramEnabled();

/**
 * Возвращает текст подсказки при списании бонусов
 */
export const selectBonusHint = (isTablet: boolean) => (state: TState): IHintProps | undefined => {
    const clientBonuses = state.loyalty.info.bonuses;
    const payment = state.payment;

    const { paymentData: { paymentSum, bonusesValue }, method: currentMethod, result: { isBonusesSuccess } } = payment;
    const methodType = currentMethod?.methodType;

    if (methodType === 'sbp' && isBonusesSuccess) {
        return {
            hintType: 'success',
            hintMessage: `Списали ${bonusesValue} ${bonus(bonusesValue)} с вашего счета.`,
        };
    }

    const requiredBonusesToPay = isAbnProgramTermsEnabled
        ? paymentSum / 0.2
        : paymentSum;

    if (bonusesValue > requiredBonusesToPay || bonusesValue > clientBonuses) {
        const currentBonusesQuantity = Math.min(requiredBonusesToPay, clientBonuses);

        const notMoreThanBonuses = ((currentBonusesQuantity === 1 || currentBonusesQuantity % 10 === 1) && currentBonusesQuantity !== 11)
            ? 'бонуса'
            : 'бонусов';

        return {
            hintType: 'error',
            hintMessage: `Можно списать не больше ${currentBonusesQuantity} ${notMoreThanBonuses}.`,
        };
    }

    if (bonusesValue === 0) {
        return {
            hintType: 'error',
            hintMessage: `Невозможно списать ${bonusesValue} ${bonus(bonusesValue)}. Введите любое другое количество от 1 до ${clientBonuses}. Если не хотите списывать бонусы, просто уберите галочку.`,
        };
    }

    if (methodType === 'sbp' && paymentSum - bonusesValue > 0) {
        const hintMessage = isTablet
            ? 'Когда вы нажмёте «Оплатить», сначала мы спишем бонусы, а когда вы подтвердите платёж в мобильном приложении вашего банка, спишем и деньги.'
            : 'Когда вы нажмёте «Показать QR-код», сначала мы спишем бонусы, а когда отсканируете его, спишем и деньги.';

        return {
            hintType: 'info',
            hintMessage,
        };
    }
};
